# Note: to use this, place amount-form-init directive on forms that need the
# aria-describedby of input items to be toogled based on presence of error.
angular.module("avant.customer_applications.directives").directive "amountFormInit", () ->
  link: (scope, element, attr) ->
    scope.initAriaDescribedBy = (elem) ->
      angular.forEach elem.find(".form__input"), (input) ->
        if input.hasAttribute("describedby-valid")
          input.setAttribute("aria-describedby", input.getAttribute("describedby-valid"))

    scope.initAriaDescribedBy(element)